import {createRoot} from '@wordpress/element';
import SpacesList from './components/SpacesList';

window.addEventListener('DOMContentLoaded', (event) => {
    const blockElements = document.getElementsByClassName(`ebo-spaces-list`);
    for (let blockElement of blockElements) {
        const attributes = JSON.parse(blockElement.dataset.gutenbergAttributes);
        createRoot(blockElement).render(<SpacesList {...attributes}/>);
    }
});
